import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface PageLoaderContextType {
	isLoading: boolean;
	showLoader: () => void;
	hideLoader: () => void;
}

const PageLoaderContext = createContext<PageLoaderContextType | undefined>(undefined);

interface PageLoaderProviderProps {
	children: ReactNode;
}

export function PageLoaderProvider({ children }: PageLoaderProviderProps) {
	const [isLoading, setIsLoading] = useState(false);

	const showLoader = useCallback(() => {
		setIsLoading(true);
	}, []);

	const hideLoader = useCallback(() => {
		setIsLoading(false);
	}, []);

	return <PageLoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>{children}</PageLoaderContext.Provider>;
}

export const usePageLoader = () => {
	const context = useContext(PageLoaderContext);
	if (context === undefined) {
		throw new Error("usePageLoader must be used within a PageLoaderProvider");
	}
	return context;
};
